<script>

	export default {
		name: 'company',
		props: [
			'subscriptionExpireDate',
			'subscriptionId',
			'company'
		],
		computed: {
			subExpireDate() {
				const oneDay = 24 * 60 * 60 * 1000;
				const firstDate = new Date();
				const secondDate = new Date(this.subscriptionExpireDate);
				const diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(oneDay)));
				if (diffDays > 31) {
					return false;
				} else {
					return diffDays;
				}
			}
		}
	}

</script>

<template>
	<router-link
		:class='{company, [company]: company, "enabled": subExpireDate }'
		:to='`/company/${company}`'
		tag='button'
	>
		<img class='logo' :src='`/static/companies/${company}.svg`'>
		<div class='remaining' v-if='subExpireDate'>
			<span class='day'>{{ subExpireDate }}</span>&nbsp;Days
		</div>
	</router-link>
</template>


// WEBPACK FOOTER //
// src/components/Company/Company.vue